<ng-container rtBlock="sc-app-header">
    <header rtElem="bar">
        <a rtElem="logo" routerLink="/" qa-dataid="header-logo">
            <span rtElem="logo-mark" aria-hidden="true"></span>
            <span rtElem="logo-word">GoldenCalc</span>
            <span rtElem="logo-subtitle" i18n="@@appBrandSubtitle">конструктор</span>
        </a>

        <!-- A tap on any link closes the folded phone menu -->
        <nav
            id="sc-app-header-menu"
            rtElem="menu"
            aria-label="Main"
            i18n-aria-label="@@navMainLabel"
            qa-dataid="header-menu"
            [rtMod]="{ open: menuOpen() }">
            <span rtElem="menu-caption" aria-hidden="true" i18n="@@navCaptionCalculators">Калькуляторы</span>
            <a
                rtElem="menu-link"
                routerLink="/calc/straight"
                i18n="@@stairTypeStraight"
                qa-dataid="header-menu-link"
                data-link="straight"
                [rtMod]="{ active: activeStairType() === 'straight' }"
                (click)="closeMenu()">
                Прямая
            </a>
            <a
                rtElem="menu-link"
                routerLink="/calc/l"
                i18n="@@stairTypeLShape"
                qa-dataid="header-menu-link"
                data-link="l-shape"
                [rtMod]="{ active: activeStairType() === 'l-shape' }"
                (click)="closeMenu()">
                Г-образная
            </a>
            <a
                rtElem="menu-link"
                routerLink="/calc/u"
                i18n="@@stairTypeUShape"
                qa-dataid="header-menu-link"
                data-link="u-shape"
                [rtMod]="{ active: activeStairType() === 'u-shape' }"
                (click)="closeMenu()">
                П-образная
            </a>
            <a
                rtElem="menu-link"
                routerLink="/calc/spiral"
                i18n="@@stairTypeSpiral"
                qa-dataid="header-menu-link"
                data-link="spiral"
                [rtMod]="{ active: activeStairType() === 'spiral' }"
                (click)="closeMenu()">
                Винтовая
            </a>
            <span rtElem="menu-divider" aria-hidden="true"></span>
            <span rtElem="menu-caption" aria-hidden="true" i18n="@@navCaptionSections">Разделы</span>
            <a
                rtElem="menu-link"
                routerLink="/blog"
                routerLinkActive="sc-app-header__menu-link--active"
                i18n="@@navBlog"
                qa-dataid="header-menu-link"
                data-link="blog"
                (click)="closeMenu()">
                Блог
            </a>
            <a
                rtElem="menu-link"
                routerLink="/about"
                routerLinkActive="sc-app-header__menu-link--active"
                i18n="@@navAboutProject"
                qa-dataid="header-menu-link"
                data-link="about"
                (click)="closeMenu()">
                О проекте
            </a>
            <a
                rtElem="menu-link"
                routerLink="/contacts"
                routerLinkActive="sc-app-header__menu-link--active"
                i18n="@@navContacts"
                qa-dataid="header-menu-link"
                data-link="contacts"
                (click)="closeMenu()">
                Контакты
            </a>
        </nav>

        <div rtElem="tools">
            <sc-language-switcher
                qa-dataid="header-language-switcher"
                [currentLocale]="currentLocale()"
                [ruHref]="ruHref()"
                [enHref]="enHref()"
                (localeSelected)="onLocaleSelected($event)" />

            @if (!compact()) {
                <a rtElem="cta" routerLink="/calc/straight" i18n="@@navOpenConstructor" qa-dataid="header-open-constructor">
                    Открыть конструктор →
                </a>
            }

            <!-- native-ok: a bare icon button of the site header; the kit button brings its own frame and padding the mockup does not have -->
            <button
                rtElem="menu-toggle"
                type="button"
                qa-dataid="header-menu-toggle"
                aria-controls="sc-app-header-menu"
                [attr.aria-expanded]="menuOpen()"
                [attr.aria-label]="menuOpen() ? closeMenuLabel : openMenuLabel"
                (click)="toggleMenu()">
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    aria-hidden="true">
                    @if (menuOpen()) {
                        <path d="M6 6l12 12M18 6L6 18" />
                    } @else {
                        <path d="M4 7h16M4 12h16M4 17h16" />
                    }
                </svg>
            </button>
        </div>
    </header>

    @if (menuOpen()) {
        <div rtElem="menu-backdrop" qa-dataid="header-menu-backdrop" aria-hidden="true" (click)="closeMenu()"></div>
    }
</ng-container>
